<template>
  <section class="w-full relative" id="function">
    <div
      class="w-full max-w-7xl mx-auto bg-[#FFFFFF] pt-[40px] pb-[120px] [@media(max-width:1280px)]:px-[60px] grid gap-2 grid-cols-1 lg:grid-cols-[30%_1fr]"
    >
      <div class="borderStyle p-[16px] w-full h-full">
        <img class="w-[38px] h-[38px]" src="@/assets/imgs/pageFunc/icon1.png" alt="logo" />
        <div class="text-[15px] font-bold mt-[16px] italic">Assist</div>
        <div class="text-[16px] text-[#666666] mt-[5px]">
          Share your heart and lift others up. In this special space, women post their prayer needs, life challenges, or spiritual questions —
          and receive kind, faith-filled replies from sisters in Christ. Together, we pray, comfort, and grow stronger in the Lord.
        </div>
        <img class="w-full mt-[16px]" src="@/assets/imgs/pageFunc/help.png" alt="send message logo" />
      </div>
      <div class="right flex-1 w-full grid gap-2 grid-cols-1 [@media(min-width:662px)]:grid-cols-2">
        <div class="borderStyle p-[16px] w-full h-full">
          <img class="w-[38px] h-[38px]" src="@/assets/imgs/pageFunc/icon2.png" alt="player logo" />
          <div class="text-[15px] font-bold mt-[16px] italic">Daily Prayers</div>
          <div class="text-[16px] text-[#666666] mt-[5px]">
            Start and end your day with peace. Each brings a gentle prayer to center your heart on God’s promises, and helps you rest in His
            care. Thoughtfully written for women, these prayers help you stay close to God each day.
          </div>
        </div>
        <div class="borderStyle p-[16px] w-full h-full">
          <img class="w-[38px] h-[38px]" src="@/assets/imgs/pageFunc/icon3.png" alt="reading logo" />
          <div class="text-[15px] font-bold mt-[16px] italic">Women's Bible Reading</div>
          <div class="text-[16px] text-[#666666] mt-[5px]">
            Read and meditate on the timeless beauty of the King James Version. Whether you’re studying deeply or just reading for comfort, the
            clean design and intuitive navigation make it easy to spend time with Scripture every day.
          </div>
        </div>
        <div class="borderStyle p-[16px] w-full h-full">
          <img class="w-[38px] h-[38px]" src="@/assets/imgs/pageFunc/icon4.png" alt="quiz logo" />
          <div class="text-[15px] font-bold mt-[16px] italic">Bible Quiz</div>
          <div class="text-[16px] text-[#666666] mt-[5px]">
            Deepen your Bible knowledge in a fun and interactive way. Challenge yourself with hundreds of questions that test your understanding
            of God’s Word — and watch your faith knowledge grow day by day.
          </div>
        </div>
        <div class="borderStyle p-[16px] w-full h-full">
          <img class="w-[38px] h-[38px]" src="@/assets/imgs/pageFunc/icon5.png" alt="Devotionals logo" />
          <div class="text-[15px] font-bold mt-[16px] italic">Devotionals</div>
          <div class="text-[16px] text-[#666666] mt-[5px]">
            Find daily inspiration that speaks to your soul. Each devotional connects Scripture to real-life struggles, guiding you toward
            healing, hope, and strength through God’s Word. Perfect for your quiet time or group reflection.
          </div>
        </div>
      </div>
    </div>

    <img class="absolute bottom-[-1px] right-0 w-full" src="@/assets/imgs/bl2.png" alt="decor" />
  </section>
</template>

<script setup lang="ts"></script>

<style lang="less" scoped>
.borderStyle {
  border: 1px solid #cccccc;
  border-radius: 8px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
  &:hover {
    transform: scale(1.05);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  }
}
</style>
